import { ProductCondition } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { PRODUCT_CONDITIONS } from '../product-state';

export const LOAD_CONDITIONS = '[CustomCatalog] Conditions Load';
export const LOAD_CONDITIONS_SUCCESS = '[CustomCatalog] Conditions Load Success';
export const LOAD_CONDITIONS_FAIL = '[CustomCatalog] Conditions Load Fail';
export const LOAD_CONDITIONS_RESET = '[CustomCatalog] Conditions Load Reset';

export class LoadProductConditions extends StateUtils.EntityLoadAction {
  readonly type = LOAD_CONDITIONS;

  constructor(public productCode: string) {
    super(PRODUCT_CONDITIONS, productCode);
  }
}

export class LoadProductConditionsSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_CONDITIONS_SUCCESS;

  constructor(
    public productCode: string,
    public payload: ProductCondition[],
  ) {
    super(PRODUCT_CONDITIONS, productCode, payload);
  }
}

export class LoadProductConditionsFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_CONDITIONS_FAIL;

  constructor(
    public productCode: string,
    payload: any,
  ) {
    super(PRODUCT_CONDITIONS, productCode, payload);
  }
}

export class LoadProductConditionsReset extends StateUtils.EntityLoaderResetAction {
  readonly type = LOAD_CONDITIONS_RESET;

  constructor(public productCode: string) {
    super(PRODUCT_CONDITIONS, productCode);
  }
}

export type ConditionsAction = LoadProductConditions | LoadProductConditionsSuccess | LoadProductConditionsFail;
